import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import FieldList from 'Components/Universal/Questionnaire/Fields/FieldList';

const ExtraordinaryLifeChangePicker = ({
  clientResource, setChangesCount, LifeChanges,
}) => {
  return pickFunction(clientResource, {
    [fr.relationships.default.name]: () => (<FieldList
      onCountUpdate={setChangesCount}
      label="Anticipated extraordinary family, career, residence changes"
      addLabel="Add a change"
      keyPrefix="lifeChanges"
      Of={LifeChanges}
    />),
  });
};

export default ExtraordinaryLifeChangePicker;
